<div [class]="cx('panel')">
  <ng-content />

  <div [class]="cx('list')">
    <ng-container *ngTemplateOutlet="primary()" />
  </div>

  @if (secondary()) {
    <div [class]="cx('list') + ' ' + cx('secondary')">
      <ng-container *ngTemplateOutlet="secondary()" />
    </div>
  }
</div>
